import type { CompetitorsDiscount } from '@/pages/PurchasesContainer/PurchasesRequests/api/Request.interface';

/**
 * Get the minimum discount from CompetitorsDiscounts array
 */
export const getMinDiscount = (discounts?: CompetitorsDiscount[]): number => {
  if (!discounts || discounts.length === 0) return 0;

  return Math.min(...discounts.map((d) => d.Discount || 0));
};

/**
 * Get the maximum discount from CompetitorsDiscounts array
 */
export const getMaxDiscount = (discounts?: CompetitorsDiscount[]): number => {
  if (!discounts || discounts.length === 0) return 0;

  return Math.max(...discounts.map((d) => d.Discount || 0));
};

/**
 * Get the total count of discounts in CompetitorsDiscounts array
 */
export const getDiscountsCount = (
  discounts?: CompetitorsDiscount[],
): number => {
  if (!discounts) return 0;

  return discounts.length;
};

/**
 * Get the count of distinct clients in CompetitorsDiscounts array
 */
export const getDistinctClientCount = (
  discounts?: CompetitorsDiscount[],
): number => {
  if (!discounts || discounts.length === 0) return 0;

  const uniqueClientIds = new Set(
    discounts.filter((d) => d.ClientID?._id).map((d) => d.ClientID._id),
  );

  return uniqueClientIds.size;
};

/**
 * Check if there's only one supplier with discounts
 */
export const hasOnlyOneSupplier = (
  discounts?: CompetitorsDiscount[],
): boolean => {
  return getDistinctClientCount(discounts) === 1;
};

/**
 * Get a summary of discount statistics
 */
export const getDiscountStats = (discounts?: CompetitorsDiscount[]) => {
  return {
    min: getMinDiscount(discounts),
    max: getMaxDiscount(discounts),
    count: getDiscountsCount(discounts),
    countSuppliers: getDistinctClientCount(discounts),
    countOffers: discounts?.length || 0,
    underRequest: 0,
  };
};
